import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { DptmasterService } from 'src/app/services/dptmaster.service';
import { DivisionService } from 'src/app/services/division.service';
import { AlertService } from 'src/app/services/alert.service';
import { InputformatService } from 'src/app/services/inputformat.service';
@Component({
  selector: 'app-machinary-categoryassign',
  templateUrl: './machinary-categoryassign.component.html',
  styleUrls: ['./machinary-categoryassign.component.scss']
})

export class MachinaryCategoryassignComponent implements OnInit {
  @Input() actionId: any;
  @Input() resultdata: any;
  @Output() backComp = new EventEmitter<any>();
  valuesForm!: FormGroup;
  value: any;
  compVal: any[] = [];
  classificationval: any[] = [];
  selectedValue: any[];
  id: any;
  GetByIdResponse: any;
  filtercompVal: any[];
  filterclassificationVal: any[];

  constructor
    (
      private fb: FormBuilder,
      private location: Location,
      private dptmasterservice: DptmasterService,
      private divisionService: DivisionService,
      private alertService: AlertService,
      private inputFormatService : InputformatService

    ) { }

  ngOnInit(): void {
    this.id = this.resultdata.id ? this.resultdata.id : 0
    this.initializeForm();
    // this.getLookup();
    this.MachinaryclassificationLookup()

    if (this.id) {
      this.getmachinary(this.id);
    }

  }



  initializeForm() {
    this.valuesForm = this.fb.group({
      name: new FormControl('', Validators.required),
      // machinaryCategoryType: new FormControl('', Validators.required),
      MachinaryClassificationId: new FormControl('', Validators.required),

    });
  }
  getmachinary(id: number) {
    this.dptmasterservice.getmachinaryCategory(id).subscribe((res) => {
      this.GetByIdResponse = res

      if (this.GetByIdResponse) {
        this.valuesForm.patchValue({
          name: res.name,
          // machinaryCategoryType: res.machinaryCategoryType,
          MachinaryClassificationId: res.machinaryClassificationId
        });
      }

    })
  }
  getLookup() {
    this.dptmasterservice.MachinaryCategoryTypeLookup(true).subscribe((res) => {
      this.compVal = res
      this.filtercompVal = this.compVal.slice();


    })
  }

  MachinaryclassificationLookup() {
    this.dptmasterservice.MachinaryclassificationLookup().subscribe((res) => {
      this.classificationval = res
      this.filterclassificationVal = this.compVal.slice();


    })
  }


  back() {
    const msg = { show: true };
    this.backComp.emit(msg);
  }

  Update() {
    if (this.valuesForm.valid) {

      let data = {
        "id": this.id,
        "name": this.valuesForm.value.name,
        // "machinaryCategoryType": this.valuesForm.value.machinaryCategoryType,
        "machinaryClassificationId": this.valuesForm.value.MachinaryClassificationId
      }

      this.dptmasterservice.updategetmachinaryCategory(data).subscribe((res) => {

        if (res.isSuccess) {
          this.alertService.success(this.actionId==0 ? 'Machinary Category Saved Successfully':this.actionId==1 ? 'Machinary Category Updated Successfully':'');

          this.back()
        }
      })
    }
    else {
      this.valuesForm.markAllAsTouched();
    }
  }

  onInput(event: any, regexPattern: any): void {
    this.inputFormatService.isNumericOrHyphenOrSpace(event, regexPattern);
  }
}
